import Cookies from "js-cookie";

export const getToken = (): string | undefined => {
  const queryParams = new URLSearchParams(window.location.search);
  const tokenFromQuery = queryParams.get("token");

  if (tokenFromQuery) {
    Cookies.set("auth_token", tokenFromQuery, { expires: 365 * 20 });
    return tokenFromQuery;
  }

  return Cookies.get("auth_token");
};
